import React from "react";
import PropTypes from "prop-types";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { MarkdownBody } from "./ChatPaneStyled";

/**
 * Markdown renderer for Smart Assistant answers.
 *
 * The agentic chat engine writes GitHub-flavored markdown (headings,
 * bullet lists, tables). Answers are split into segments so inline
 * page-citation chips can follow the prose they support; the wrapper's
 * CSS keeps the LAST paragraph of a segment inline so a trailing chip
 * sits on the same line instead of dropping below.
 */
// Web links in an answer must not navigate the attorney away from the
// matter (same treatment as BriefingMarkdown).
const markdownComponents = {
  a: ({ href, children, ...rest }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>
      {children}
    </a>
  ),
};

const ChatMarkdown = ({ text }) => {
  if (!text) return null;
  return (
    <MarkdownBody>
      <Markdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
        {text}
      </Markdown>
    </MarkdownBody>
  );
};

ChatMarkdown.propTypes = {
  text: PropTypes.string,
};

ChatMarkdown.defaultProps = {
  text: "",
};

export default ChatMarkdown;
